import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga4';

import Simulador from '~/assets/img/iconDash/simulador.svg';
import LucreeProClick from '~/assets/img/iconDash/lucreePorClick.svg';
import ProgramaMercado from '~/assets/img/iconDash/programaMercado.svg';
import { StyledLink } from '../../styles';

export function ClientNavLink() {
	const { user } = useSelector((state) => state.auth);
	// const projetos = ['Iquine', 'Intelbras', 'Testes Lucree', 'Iquine_50', 'Hidracor'];

	function handleClickAcessoPGMGA4() {
		ReactGA.event({
			category: "acesso_pgm_click",
			action: "Acesso PGM",
			label: "Acesso PGM",
		});
	}

	function handleClickVendaseRecebimentosGA4() {
		ReactGA.event({
			category: "acesso_vendas_recebimentos_click",
			action: "Acesso Vendas e Recebimentos",
			label: "Acesso Vendas e Recebimentos",
		});
	}

	const toggleGA = useCallback(() => {
		if (user.dados.permissoes.view_pgm) {
			handleClickAcessoPGMGA4();
		} else {
			handleClickVendaseRecebimentosGA4();
		}
	}, []);

	return (
		<>
			{user.dados.maquina_virtual && (
				<Link
					style={{ textDecoration: 'none' }}
					to="/client/maquina-virtual"
					className="d-block text-right ml-5">
					<img
						src={LucreeProClick}
						className="mr-1"
						height="20px"
						width="20px"
						alt="lucree"
					/>
					{/* <LinkOutlined className="mr-1" /> */}
					Lucree por click
				</Link>
			)}

			{user.dados.permissoes.view_simulador &&
				<Link
					to="/client/simulador"
					style={{ textDecoration: 'none' }}
					className="d-block text-right ml-5">
					<img
						src={Simulador}
						className="mr-1"
						height="20px"
						width="20px"
						alt="lucree"
					/>
					Simulador
				</Link>
			}

			<Link
				to="/client/transacoes"
				onClick={toggleGA}
				style={{ textDecoration: 'none' }}
				className="d-block text-right ml-5">
				<img
					src={ProgramaMercado}
					className="mr-1"
					height="20px"
					width="20px"
					alt="lucree"
				/>
				{user.dados.permissoes.view_pgm
					? 'Programa de Mercado'
					: 'Vendas e Recebimentos'}
			</Link>
			{user.dados.cargo.split(" ")[0].toLowerCase() !== 'distribuidor' && user.dados.cargo.toLowerCase() !== 'industria' && user.dados.documento && user.dados.documento.length >= 14 &&
				<StyledLink
					className="d-block text-right ml-5"
					target="_blank"
					style={{ textDecoration: 'none', fontWeight: 'normal' }}
					href="https://lucree.com.br/"
					rel="noreferrer">
					Conheça a
					{' '}
					<b>Lucree</b>
				</StyledLink>
			}
		</>
	);
}
